import { AppData, Log } from "@lightningjs/sdk";
import { AppSetup } from "./app-setup";
import { PLATFORM } from "./enum";
import { Helper } from "./helper";
import { Logger } from "./logger";
import VastParser from "./vast-parser";

export class AdHandler {
  isInitialized=false;
  constructor() {}
  showHideAdLabel = (action: any) => {    
    if (action == "hide") {
      $(".custom-ad-label").css("display", "none");
    } else {
      $(".custom-ad-label").css("display", "block");
    }
  };

  updateAdLabel = (adNumber: any, totalAds: any) => {
    if (
      adNumber !== null &&
      adNumber !== undefined &&
      totalAds !== null &&
      totalAds !== undefined
    ) {
      //$('.custom-ad-label .custom-ad-number').text(adNumber + ' of ' + totalAds);
    } else {
      //$('.custom-ad-label .custom-ad-number').text('');
    }
  };

  initializeAdsConfig = () => {
    const { appConfig, platform, appState } = AppData as AppSetup;
    const app = appState?.getApp();
    let adObj = app?.adObj;
    let ads = app?.ads;
    let testInfo = appConfig?.testInfo;
    //parse app configuration
    var rsp = app?.appApiConfig.adsdkConfig;
    Logger.printLog("data", "fn adHandler.initialize# rsp: ", rsp);
    if (rsp.adActivation == "true" || rsp.adActivation == true) {
      adObj.adActivation = true;
      if(appConfig.disableAds){
      } else {
        appConfig.disableAds = false;
      }
    } else {
      adObj.adActivation = false;
      appConfig.disableAds = true;
    }

    if (rsp.adProbability) {
      adObj.adProbability = parseInt(rsp.adProbability);
    } else adObj.adProbability = 0;

    if (rsp.adInterval) {
      // pre roll ad interval
      adObj.adInterval = parseInt(rsp.adInterval);
    } else adObj.adInterval = 0;

    if (rsp.firstadInterval) {
      // when to play first preroll
      adObj.firstadInterval = parseInt(rsp.firstadInterval);
    } else adObj.firstadInterval = 0;

    if (rsp.nonmidrollsize) {
      // how many prerolls to play in one go
      adObj.nonmidrollsize = parseInt(rsp.nonmidrollsize);
    } else adObj.nonmidrollsize = 0;

    // multiple ad buckets to be used for ad fallback / waterfalling
    ads.adSdksCount = 0; //resetting the adSDK Count on reload the app.

    if (rsp.providers !== undefined) {
      adObj.adsdklist = new Array();

      for (let i = 0; i < rsp.providers.length; i++) {
        // just a static number in loop as there was some issue with running .each loop in the object
        let providerConf = app?.appApiConfig.adsdkConfig.providers[i];
        Logger.printLog(
          "data",
          "fn adHandler.initialize# appConfig.adsdk",
          providerConf
        );

        if (
          providerConf !== undefined &&
          providerConf.type == "video" &&
          providerConf.name !== "yume"
        ) {
          let sdkPriority = providerConf.priority;
          // adObj.adsdklist[sdkPriority] = providerConf;
          adObj.adsdklist.push(providerConf);
          ads.adSdksCount++;
        } else {
          // break;
        }
      }
      //adObj.adsdklist = this.sortSdkArray(adObj.adsdklist);
      adObj.adsdklist = adObj.adsdklist.sort(Helper.compare);

      if (adObj.adsdklist[ads.adSdksCount - 1] !== undefined) {
        ads.adSdkCalled = ads.adSdksCount - 1;
        adObj.adUrl = adObj.adsdklist[ads.adSdksCount - 1].url;

        if (adObj.adUrl == "" && appConfig.adSdkToUse !== "freewheel") {
          adObj.adActivation = false;
          appConfig.disableAds = true;
        } else {
            if (testInfo.testAdMode == true) {
                adObj.adsdklist = testInfo.testAdProviders;
                ads.adSdksCount = adObj.adsdklist.length;
            }
        }
      } else {
        adObj.adUrl = "";
        const appApiConfig = appState?.getAppApiConfig()
        const genre = appApiConfig?.appConfig?.genre
        if(genre && genre.toLocaleLowerCase() !== 'movies'){
          appConfig.adSdkToUse = 'ima';
        }
        if (appConfig.adSdkToUse !== "freewheel") {
          adObj.adActivation = false;
          appConfig.disableAds = true;
        }
      }
    }

    // for midroll ad implementation
    if (rsp) {
      if (rsp.enableMidAd) {
        if (rsp.enableMidAd == "true" || rsp.enableMidAd == true) {
          adObj.enableMidAd = true;
        } else {
          adObj.enableMidAd = false;
        }

        if (rsp.midAdRepeatMode == "true" || rsp.midAdRepeatMode == true)
          // whether to repeat mid ads in the same video
          adObj.midAdRepeatMode = true;
        else adObj.midAdRepeatMode = false;

        if (rsp.midAdTimeInterval == "")
          // after how many minutes a midroll should be requested
          adObj.midAdTimeInterval = 0;
        else adObj.midAdTimeInterval = parseInt(rsp.midAdTimeInterval);

        if (rsp.midrollsize == "")
          // how many midrolls to play in one go
          adObj.midrollsize = 0;
        else adObj.midrollsize = parseInt(rsp.midrollsize);
      } else {
        adObj.enableMidAd = false;
      }
    }

    // Temporary - to enable or disable ads appwise and platform wise
    /*if (
      appConfig.platform_id == PLATFORM.COX ||
      appConfig.platform_id == PLATFORM.AIRTELSHAW
    ) {
      appConfig.disableAds = true;
      adObj.adActivation = false;
    }*/

    /*if(appConfig.platform_id == PLATFORM.SHAW) {
      appConfig.disableAds = true;
      adObj.adActivation = false;
    }*/

    // only used with ima sdk, does not affect freewheel sdk
    appConfig.useVmap = false;
    // if(!appConfig.appsWithoutVmap.includes(parseInt(appConfig.siteId))) {
    // 	appConfig.useVmap = true;
    // } else {
    // 	appConfig.useVmap = false;
    // }

    const bugAdsConfig = app?.appApiConfig.adsdkConfig.bugAds;
    const bugadenabled =
      !$.isEmptyObject(bugAdsConfig) && Helper.toBoolean(bugAdsConfig?.bugadenabled, false);
    if (!bugadenabled) {
      Logger.printLog("adlog", "bug ads config empty or disabled - setting enableBugAds to false");
      appConfig.enableBugAds = false;
    } else {
      appConfig.enableBugAds = true;
      VastParser.prefetch();
    }

    if (appConfig?.enablePauseAds && bugadenabled) {
      VastParser.prefetch('pause');
    } else {
      Logger.printLog("adlog", "pause ads disabled - skipping pause ad prefetch");
    }
  };

  sortSdkArray = (arr: any) => {
    return arr.sort((a: any, b: any) => {
      return a.priority - b.priority;
    });
  };

  getCuePoints = (videoInfo: any) => {
    const { appConfig, platform, appState } = AppData as AppSetup;
    const app = appState?.getApp();
    let adObj = app?.adObj;
    let ads = app?.ads;
    ads.currentVodCuePoints = [];
    if (adObj.adActivation !== false && adObj.enableMidAd !== false) {
      Logger.printLog("adlog", "getting ad breaks", "");
      if (
        app?.appApiConfig.adsdkConfig.enableCuePts == true ||
        app?.appApiConfig.adsdkConfig.enableCuePts == "true"
      ) {
        if (videoInfo.ad_breaks !== null && videoInfo.ad_breaks !== "") {
          var ad_breaks = videoInfo.ad_breaks.split(",");
          /*(ad_breaks).forEach(function (i, val) {
						ads.currentVodCuePoints[i] = parseInt(val);
					});*/
          $(ad_breaks).each(function (i, val) {
            ads.currentVodCuePoints[i] = parseInt(val);
            if(appConfig.prefetchAds == true) {
							ads.currentVodCuePoints[i] = parseInt(val) - appConfig.prefetchTiming;
						}
          });
        } else {
          ads.currentVodCuePoints = this.calculateMidAdPoints(
            videoInfo.runtime
          );
        }
      } else {
        ads.currentVodCuePoints = this.calculateMidAdPoints(videoInfo.runtime);
      }
    }

    ads.currentVodCuePointsCopy =[];
    ads.currentVodCuePointsCopy = JSON.parse(JSON.stringify(ads.currentVodCuePoints));


    this.getPlayPoints()
    if(appConfig.enableIMAAdPodding && appConfig.enableFusePrefetch){
      var fusePrefetchInterval = appConfig.fusePrefetchInterval;
      if (appConfig.adSdkToUse == 'freewheel'){
        fusePrefetchInterval = appConfig.fusePrefetchInterval+appConfig.prefetchTiming;
      }
      ads?.currentVodPFPoints = Helper.subtractSecondsWithMinimum(ads.currentVodCuePoints,fusePrefetchInterval)
      ads?.currentVodPFInfo={};
      for (let i = 0; i < ads.currentVodPFPoints.length; i++) {
        const pfTime = currentApp.ads.currentVodPFPoints[i];
        const cueTime = currentApp.ads.currentVodCuePoints[i];
        ads?.currentVodPFInfo[pfTime]={
          pfTime:pfTime,
          cueTime:cueTime,
          playTime:ads.currentVodPlayPoints[i],
          status:"",
        }
      }

    }
    Logger.printLog("data", "Video Points Cue ", ads.currentVodCuePoints);
    Logger.printLog("data", "Video Points Play ", ads.currentVodPlayPoints);    
    Logger.printLog("data", "Video Points PF ", ads.currentVodPFPoints);
    Logger.printLog("data", "Video Points PF info ", ads.currentVodPFInfo);
    return ads.currentVodCuePoints;
  };

  getPlayPoints = () => {
    const { appConfig, platform, appState } = AppData as AppSetup;
    const app = appState?.getApp();
    let adObj = app?.adObj;
    let ads = app?.ads;
		if(appConfig.prefetchAds == true && ads.currentVodCuePoints.length > 0) {
			ads.currentVodPlayPoints = [];
			$(ads.currentVodCuePoints).each(function(i,val){
				ads.currentVodPlayPoints[i] = val + appConfig.prefetchTiming
			});
		}
	};

  calculateMidAdPoints = (videoDuration: any) => {
    const { appConfig, appState } = AppData as AppSetup;
    const app = appState?.getApp();
    let adObj = app?.adObj;
    let midAdPoints = new Array();
    if (
      videoDuration !== null &&
      videoDuration !== undefined &&
      videoDuration !== 0
    ) {
      if (adObj.enableMidAd == true && adObj.midAdTimeInterval > 0) {
        let midAdTimeIntervalInSeconds = adObj.midAdTimeInterval * 60;
        let noMidAdPoints = Math.floor(
          videoDuration / midAdTimeIntervalInSeconds
        );
        Logger.printLog("data", "noMidAdPoints, midAdTimeIntervalInSeconds: ", [
          noMidAdPoints,
          midAdTimeIntervalInSeconds,
        ]);
        let vodTime = 0;
        for (let i = 1; i <= noMidAdPoints; i++) {
          vodTime = vodTime + midAdTimeIntervalInSeconds;
          // if((videoDuration - vodTime) > midAdTimeIntervalInSeconds) {
          //midAdPoints.push(vodTime);
          // }
          if(appConfig.prefetchAds == true) {
            midAdPoints.push(vodTime- appConfig.prefetchTiming);
          } else {
            midAdPoints.push(vodTime);
          }
        }
        Logger.printLog("data", "vodTime, midAdPoints", [vodTime, midAdPoints]);
      }
    }
    return midAdPoints;
  };

  checkAndUpdateSkippedPods = () => {
    Logger.printLog("adlog", "checkAndUpdateSkippedPods() called", "");
    const { appState } = AppData as AppSetup;
    const app = appState?.getApp();
    let ads = app?.ads;
    let mainVideoPlayer: any = null;
    if (
      mainVideoPlayer == null ||
      typeof mainVideoPlayer.ima == "undefined" ||
      typeof mainVideoPlayer.ima.controller === "undefined"
    ) {
      return;
    }
    ads.skippedPods = [];
    var cuePts = mainVideoPlayer.ima.controller.getAdsManager().getCuePoints();
    cuePts.forEach(function (i, val) {
      if (val < mainVideoPlayer.currentTime()) {
        ads.skippedPods.push(i);
      }
    });
  };

  /*
		@description - To generate a bundle id in a particular format of platform.ChannelName for all iptv appps.
		@param - none
		@returnValue - generated bundle id
	*/
  getBundleId = () => {
    const { appConfig, appState, platform } = AppData as AppSetup;
    const app = appState?.getApp();
    const appApiConfig = app?.appApiConfig;
    let adObj = app?.adObj;
    let ads = app?.ads;
    let platformName = "";
    if (
      appConfig.platform_id == PLATFORM.COMCAST &&
      appApiConfig.appConfig.comcastAppBundleId !== null
    ) {
      return appApiConfig.appConfig.comcastAppBundleId;
    } else if (
      appConfig.platform_id == PLATFORM.COX &&
      appApiConfig.appConfig.coxAppBundleId !== null
    ) {
      return appApiConfig.appConfig.coxAppBundleId;
    }
    if (appConfig.platform_id == PLATFORM.LG) {
      platformName = "lgiptv";
    }
    if (appConfig.platform_id == PLATFORM.SAMSUNG) {
      platformName = "Samsung";
    }
    if (appConfig.platform_id == PLATFORM.WINDOWS) {
      platformName = "windows";
    }
    if (appConfig.platform_id == PLATFORM.WINDOWS && appConfig.isXBox == true) {
      platformName = "xbox";
    }
    if (appConfig.platform_id == PLATFORM.VIZIO) {
      platformName = "vizio";
    }
    if (appConfig.platform_id == PLATFORM.COMCAST) {
      platformName = "comcast";
    }
    if (appConfig.platform_id == PLATFORM.FOXXUM) {
      platformName = "foxxum";
    }
    if (appConfig.platform_id == PLATFORM.ZEASN) {
      platformName = "zeasn";
    }
    if (appConfig.platform_id == PLATFORM.NETGEM) {
      platformName = "netgem";
    }
    if (appConfig.platform_id == PLATFORM.NETRANGE) {
      platformName = "netrange";
    }
    if (appConfig.platform_id == PLATFORM.PANASONIC) {
      platformName = "panasonic";
    }
    if (appConfig.platform_id == PLATFORM.COX) {
      platformName = "cox";
    }
    if (appConfig.platform_id == PLATFORM.ROGERS) {
      platformName = "rogers";
    }
    if (appConfig.platform_id == PLATFORM.SHAW) {
      platformName = "shaw";
    }
    if (appConfig.platform_id == PLATFORM.PLATCO) {
      platformName = "platco";
    }
    if (appConfig.platform_id == PLATFORM.VIDAA) {
      platformName = "vidaa";
    }
    // VegaOS (FireTV) - platform name used in the ad bundle id
    if (appConfig.platform_id == PLATFORM.FIRETV) {
      platformName = "firetv";
    }
    let appName = appApiConfig.appConfig.site_name;
    if (
      appConfig.platform_id == PLATFORM.COMCAST ||
      appConfig.platform_id == PLATFORM.COX ||
      appConfig.platform_id == PLATFORM.ROGERS ||
      appConfig.platform_id == PLATFORM.SHAW ||
      appConfig.platform_id == PLATFORM.PLATCO
    ) {
      appName = Helper.capitalizeFirstLetter(appName, true);
    } else {
      appName = appName.toLowerCase();
			appName = appName.replace(/\s+/g, '').toLowerCase();
    }
    let bundleId = encodeURI(platformName + "." + appName);
    if (appConfig.adSdkToUse == "freewheel") {
      bundleId = encodeURI(appName + "." + platformName);
    } else {
      bundleId = platformName + "." + platform?.getAppNameMacro(appName, appConfig?.siteId, true).toLowerCase();
    }
    // VegaOS (FireTV) - bundle id comes from the launch param
    if (appConfig?.platform_id == PLATFORM.FIRETV) {
        let platformChannelName: any = Helper.urlParam('platformChannelName', location.search);
        if(platformChannelName){
            bundleId = platformChannelName;
        }
    }
    return bundleId;
  };

  setAdState = (adType = "video") => {
    Logger.printLog("data", "adHandler.setAdState >>> called", adType);
    const { appState } = AppData as AppSetup;
    const app = appState?.getApp();
    let ads = app?.ads;
    appState.player.userInteraction = false;
    if (adType == "bugad") return;
    if (appState.player.pausedTime == 0) {
      ads.adPlaying = true;
    } else {
      ads.adPlaying = true;
      ads.midAdPlaying = true;
    }
  };

  resetAdState = (type = "none") => {
    Logger.printLog("info", "adHandler.resetAdState >>> called", "");
    const { appState } = AppData as AppSetup;
    const app = appState?.getApp();
    let ads = app?.ads;
    let adObj = app?.adObj;
    appState.player.userInteraction = true;
    ads.adPlaying = false;
    ads.midAdPlaying = false;
    ads.preRollRequestMade = false;
    Helper.preloaderDisplay("hide");
    if (type == "none") {
      if (ads.preRollAdsRequested >= adObj.nonmidrollsize) {
        ads.preRollAdsRequested = 0; // reset
      }
      if (ads.midRollAdsRequested >= adObj.midrollsize) {
        ads.midRollAdsRequested = 0; // reset
      }
    }
  };


  createAdVideoElem () {
    if(document.getElementById('displayBase')){
      return;
    }
    var elemDiv = document.createElement("div");
    elemDiv.setAttribute("id", "displayBase");
    var elemVideo = document.createElement("VIDEO");
    elemVideo.setAttribute("id", "adVideo");
    elemDiv.style.cssText =
      "position:absolute;width:100%;height:100%;opacity:0;z-index:100;background:#000;pointer-events:none;";
    elemVideo.style.cssText =
      "height:100vh;width:100%;pointer-events:none;pointer-events:none;";
    elemDiv.appendChild(elemVideo);

    var elemDivIMA = document.createElement("div");
    elemDivIMA.setAttribute("id", "displayBaseIMA");
    elemDivIMA.style.cssText =
      "position:absolute;width:100%;height:100%;pointer-events:none;top:0px";
    elemDiv.appendChild(elemDivIMA);

    $(elemDiv).append(
      `<label class="custom-ad-label" style="bottom: 24px;vertical-align: bottom;color: #fff;background: #00000094;padding: 2px 10px;width: auto;position: absolute;left:25px;display:none;">Video will play after ads <span class="custom-ad-number"></span></label>`
    );


    document.body.appendChild(elemDiv);
    //document.body.appendChild(elemDivIMA);
  }

  removeAdVideoElem () {
    const element = document.getElementById("displayBase");
    element?.remove();
  }
  showAdVideoElem () {
    const element = document.getElementById("displayBase");
    $(element).css('opacity', '1');
  }
  hideAdVideoElem () {
    const element = document.getElementById("displayBase");
    $(element).css('opacity', '0');
  }
}
